import { Link } from "react-router-dom";
import { useWeather } from "@/lib/weather";
import { WeatherIcon } from "@/components/WeatherIcon";

const deg = (t) => (t == null ? "–" : `${Math.round(t)}°`);

// Meteo di adesso nell'intestazione: città, icona e gradi; porta alla pagina /meteo.
export function WeatherBadge({ compact = false }) {
  const { city, data } = useWeather();
  if (!city || !data) return null;
  return (
    <Link
      to="/meteo"
      data-testid={compact ? "weather-badge-mobile" : "weather-badge"}
      title={`Meteo ${city.name}: ${data.now.label}`}
      className={`${compact ? "flex md:hidden" : "hidden md:flex"} items-center gap-1.5 mr-4 text-onSurface hover:text-brand transition-colors`}
    >
      <WeatherIcon symbol={data.now.symbol} size={compact ? 15 : 17} className="text-brand shrink-0" />
      <span data-testid="weather-badge-city" className="font-sans text-sm font-medium truncate max-w-[110px]">{city.name}</span>
      <span data-testid="weather-badge-temp" className="font-sans text-sm font-bold tabular-nums">{deg(data.now.temp)}</span>
    </Link>
  );
}
